import type { HoverSegment, Stroke, UUID } from '../model/types';
import type { Repo } from '../store/repo';
import type { EngineStore } from './Engine';

type Unrevved<T> = Omit<T, 'rev'>;

export function repoStore(repo: Repo): EngineStore {
  return {
    saveStroke: (s) => repo.putStroke(s),
    journalStroke: (s) => repo.putJournal(s),
    clearJournal: (id) => repo.clearJournal(id),
    saveHover: (h) => repo.putHover(h),
  };
}

/** Keeps everything in memory. Used by the replay harness so test ink never reaches the real database. */
export class MemoryStore implements EngineStore {
  strokes: Unrevved<Stroke>[] = [];
  hover: Unrevved<HoverSegment>[] = [];
  journal = new Map<UUID, Unrevved<Stroke>>();

  async saveStroke(s: Unrevved<Stroke>) { this.strokes.push(s); }
  async journalStroke(s: Unrevved<Stroke>) { this.journal.set(s.id, s); }
  async clearJournal(id: UUID) { this.journal.delete(id); }
  async saveHover(h: Unrevved<HoverSegment>) { this.hover.push(h); }
}
